// @flow
import { createContext } from 'react';

export const OpenCloseHierarchyTreeContext = createContext({});
